<template>
  <div :class="b({'active':((active || overActive)&&!readonly),'move':moveActive,'click':disabled})"
       @mousedown.stop="handleMove"
       @mouseover.stop="handleOver"
       @mouseout.stop="handleOut"
       :style="styleName">
    <el-input ref="input"
              :class="b('focus')"
              v-model="value"></el-input>
    <div :class="b('wrapper')"
         ref="wrapper">
      <template v-if="(active || overActive || moveActive)&&!readonly">
        <div :style="styleLineName"
             :class="b('line',['left'])"></div>
        <div :style="styleLineName"
             :class="b('line',['top'])"></div>
        <div :class="b('line',['label'])"
             :style="styleLabelName">{{baseLeft}},{{baseTop}}</div>
      </template>
      <template v-for="(item,index) in rangeList"
                v-if="!readonly">
        <div :class="b('range',[item.classname])"
             :key="index"
             v-if="active"
             :style="[styleRangeName,getRangeStyle(item.classname)]"
             @mousedown.stop="rangeMove($event,item.classname)"></div>
      </template>
      <div :class="b('menu')"
           :style="styleMenuName"
           v-show="active || overActive">
        <slot name="menu"
              :zIndex="zIndex"
              :index="index"></slot>
      </div>
      <div :class="b('item')"
           ref="item">
        <slot></slot>
      </div>
      <div :class="b('mask')"
           v-if="!disabled && mask"></div>
    </div>
  </div>
</template>

<script>

const getFixed = (val = 0, len = 2) => Number(val.toFixed(len));

export default {
  name: "draggable",
  props: {
    index: {
      type: [String, Number],
    },
    mask: {
      type: Boolean,
      default: true
    },
    scale: {
      type: Number,
      default: 1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    resize: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    step: {
      type: Number,
      default: 1
    },
    zIndex: {
      type: [Number, String],
      default: 1
    },
    position: {
      type: Object,
      default: () => ({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      })
    },
  },
  data () {
    return {
      value: '',
      baseWidth: 0,
      baseHeight: 0,
      baseLeft: 0,
      baseTop: 0,
      children: {},
      moveActive: false,
      overActive: false,
      rangeActive: false,
      active: false,
      keyDown: null,
      rangeList: [
        {
          classname: "left",
        },
        {
          classname: "right",
        },
        {
          classname: "top",
        },
        {
          classname: "bottom",
        },
        {
          classname: "top-left",
        },
        {
          classname: "top-right",
        },
        {
          classname: "bottom-left",
        },
        {
          classname: "bottom-right",
        }
      ]
    };
  },
  computed: {
    scaleVal () {
      return this.scale;
    },
    styleMenuName () {
      return {
        transformOrigin: "0 0",
        transform: `scale(${this.scaleVal})`
      };
    },
    styleLineName () {
      return {
        borderWidth: this.setPx(this.scaleVal)
      };
    },
    styleRangeName () {
      const calc = 10 * this.scaleVal;
      return {
        width: this.setPx(calc),
        height: this.setPx(calc)
      };
    },
    styleLabelName () {
      return {
        fontSize: this.setPx(18 * this.scaleVal)
      };
    },
    styleName () {
      return Object.assign(
        (() => {
          if (this.active) {
            return Object.assign(
              {
                zIndex: 9999
              },
              this.styleLineName
            );
          }
          return { zIndex: this.zIndex };
        })(),
        {
          top: this.setPx(this.baseTop),
          left: this.setPx(this.baseLeft),
          width: this.setPx(this.baseWidth),
          height: this.setPx(this.baseHeight)
        }
      );
    }
  },
  watch: {
    position(val) {
      this.baseWidth = getFixed(val.width) || this.children.offsetWidth;
      this.baseHeight = getFixed(val.height) || this.children.offsetHeight;
      this.baseLeft = getFixed(val.left);
      this.baseTop = getFixed(val.top);
    },
    baseWidth (val) {
      this.$refs.wrapper.style.width = this.setPx(val);
      if (this.resize && this.children.style) {
        this.children.style.width = this.setPx(val);
      }
    },
    baseHeight (val) {
      this.$refs.wrapper.style.height = this.setPx(val);
      if (this.resize && this.children.style) {
        this.children.style.height = this.setPx(val);
      }
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    validatenull(val) {
      // 特殊判断
      if (val && parseInt(val) === 0) return false;
      const list = ['$parent'];
      if (val instanceof Date || typeof val === 'boolean' || typeof val === 'number') return false;
      if (val instanceof Array) {
        if (val.length === 0) return true;
      } else if (val instanceof Object) {
        val = this.$deepclone(val);
        list.forEach(ele => {
          delete val[ele];
        });
        for (var o in val) {
          return false;
        }
        return true;
      } else {
        if (
          val === 'null' ||
          val == null ||
          val === 'undefined' ||
          val === undefined ||
          val === ''
        ) {
          return true;
        }
        return false;
      }
      return false;
    },
    setPx(val, defval = '') {
      if (this.validatenull(val)) val = defval;
      if (this.validatenull(val)) return '';
      val = val + '';
      if (val.indexOf('%') === -1) {
        val = val + 'px';
      }
      return val;
    },
    b(el, mods) {
      const MODS = '--';
      const prefix = (name, mods) => {
        if (typeof mods === 'string') {
          return join(name, mods, MODS);
        }

        if (Array.isArray(mods)) {
          return mods.map(item => prefix(name, item));
        }

        const ret = {};
        Object.keys(mods || {}).forEach(key => {
          ret[name + MODS + key] = mods[key];
        });
        return ret;
      };
      let join = (name, el, symbol) => el ? name + symbol + el : name;
      const name = 'avue-draggable';
      if (el && typeof el !== 'string') {
        mods = el;
        el = '';
      }
      el = join(name, el, '__');

      return mods ? [el, prefix(el, mods)] : el;
    },
    init () {
      this.children = this.$refs.item.firstChild;
      this.baseWidth = getFixed(this.position.width) || this.children.offsetWidth;
      this.baseHeight = getFixed(this.position.height) || this.children.offsetHeight;
      this.baseLeft = getFixed(this.position.left);
      this.baseTop = getFixed(this.position.top);
      this.keyDown = document.onkeydown
    },
    setLeft (left) {
      this.baseLeft = left;
    },
    setTop (top) {
      this.baseTop = top;
    },
    getRangeStyle (postion) {
      const calc = (10 * this.scaleVal) / 2;
      let result = {};
      let list = postion.split("-");
      list.forEach(ele => {
        result[ele] = this.setPx(-calc);
      });
      return result;
    },
    setOverActive (val) {
      this.overActive = val;
    },
    setActive (val) {
      this.active = val;
    },
    rangeMove (e, position) {
      if (this.disabled) return
      //移动的方向
      let x, y;
      //移动的位置
      let xp, yp;
      //移动的正负
      let xc, yc;
      this.rangeActive = true;
      this.handleMouseDown();
      let disX = e.clientX;
      let disY = e.clientY;
      document.onmousemove = e => {
        this.moveActive = true;
        if (position === "right") {
          x = true;
          y = false;
        } else if (position === "left") {
          x = true;
          xp = true;
          xc = true;
          y = false;
        } else if (position === "top") {
          x = false;
          y = true;
          yp = true;
          yc = true;
        } else if (position === "bottom") {
          x = false;
          y = true;
        } else if (position === "bottom-right") {
          x = true;
          y = true;
        } else if (position === "bottom-left") {
          x = true;
          y = true;
          xp = true;
          xc = true;
        } else if (position === "top-right") {
          x = true;
          y = true;
          yp = true;
          yc = true;
        } else if (position === "top-left") {
          x = true;
          y = true;
          xp = true;
          xc = true;
          yp = true;
          yc = true;
        }
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        disX = e.clientX;
        disY = e.clientY;
        if (x) {
          let calc = left * this.step;
          if (xc) calc = -calc;
          if (xp) this.baseLeft = getFixed(this.baseLeft - calc);
          this.baseWidth = getFixed(this.baseWidth + calc);
        }
        if (y) {
          let calc = top * this.step;
          if (yc) calc = -calc;
          if (yp) this.baseTop = getFixed(this.baseTop - calc);
          this.baseHeight = getFixed(this.baseHeight + calc);
        }
      };
      this.handleClear()

    },
    handleOut () {
      this.overActive = false
      this.$emit("out", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleOver () {
      if (this.disabled) return
      this.overActive = true
      this.$emit("over", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleMove (e) {
      if (this.disabled) return
      setTimeout(() => {
        this.$refs.input.focus()
      })
      this.active = true;
      this.handleMouseDown();
      let disX = e.clientX;
      let disY = e.clientY;
      document.onmousemove = (e) => {
        let left = e.clientX - disX;
        let top = e.clientY - disY;
        disX = e.clientX;
        disY = e.clientY;
        this.baseLeft = getFixed(this.baseLeft + left * this.step);
        this.baseTop = getFixed(this.baseTop + top * this.step);
      };
      this.handleClear()
    },
    handleClear () {
      document.onmouseup = () => {
        document.onmousemove = null;
        document.onmouseup = null;
        this.handleMouseUp();
      }
    },
    handleMouseDown (e) {
      this.moveActive = true;
      this.$emit("focus", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    },
    handleMouseUp () {
      this.moveActive = false;
      this.rangeActive = false;
      this.$emit("blur", {
        index: this.index,
        width: this.baseWidth,
        height: this.baseHeight,
        left: this.baseLeft,
        top: this.baseTop
      });
    }
  }
}
</script>
<style lang="less">
.avue-draggable{
  padding: 10px;
  position: absolute;
  cursor: move;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  &__focus{
    opacity: 0;
    position: absolute !important;
    top:0;
    left:0;
    z-index: -1024;
  }
  &__mask{
    width:100%;
    height: calc(100% + 2px);
    border: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: -2px;
    left: 0;
    z-index: 1;
  }
  &--active{
    cursor: move;
    border:1px dashed #09f;
    background-color: rgba(115, 170, 229,.5);
  }
  &--move{
    opacity: .6;
    background-color:rgba(115, 170, 229,.5);
  }
  &--click{
    cursor: pointer;
  }
  &__line{
    &--left {
      position: absolute;
      border-top: 1px dashed #09f;
      width: 10000px;
      height: 0;
      top: 0;
      transform: translateX(-100%);
    }
    &--top {
      position: absolute;
      border-left: 1px dashed #09f;
      width: 0;
      height: 10000px;
      left: 0;
      transform: translateY(-100%);
    }
    &--label{
      top:-5px;
      left: -8px;
      position: absolute;
      padding: 5px;
      transform: translate(-100%,-100%);
      color: #09f;
      font-size: 18px;
      white-space: nowrap;
      cursor: move;
    }
  }
  &__menu{
    position: absolute;
    top:0px;
    left: 0px;
    background-color: #409EFF;
    font-size: 25px;
    color:#fff;
    z-index:9999;
    cursor: pointer;
  }
  &__range{
    position: absolute;
    width:10px;
    height: 10px;
    border-radius: 100%;
    z-index:9999;
    background-color: #09f;
    &--left,&--right{
      &:hover{
        cursor:ew-resize 
      }
      top:50%;
      transform: translateY(-50%);
    }
    &--left{
      left: -6px;
    }
    &--right{
      right: -6px;
    }
    &--top,&--bottom{
      &:hover{
        cursor: ns-resize
      }
      left: 50%;
      transform: translateX(-50%);
    }
    &--top{
      top: -6px;
    }
    &--bottom{
      bottom: -6px;
    }
    &--bottom-right,&--top-left{
      &:hover{
        cursor: nwse-resize
      }
    }
    &--bottom-left,&--top-right{
      &:hover{
        cursor: nesw-resize
      }
    }
    &--top-right{
      top: -6px;
      right:-6px;
    }
    &--top-left{
      top: -6px;
      left:-6px;
    }
    &--bottom-right{
      bottom: -6px;
      right:-6px;
    }
    &--bottom-left{
      bottom: -6px;
      left:-6px;
    }
  }
}
</style>